import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Product } from '../models/Product';
import { Cart } from '../models/Cart';
import { BaseService } from '../_services/base.service';
@Injectable({
    providedIn: "root",
})
export class ShoppingCartService {
    public cart : Cart;

    constructor(private http: HttpClient,private toastr: ToastrService,	private baseService: BaseService) {
        this.cart = new Cart;
        this.cart.restore();
    }

    addToCart(product: Product) {
		const msg = product.name + ' - Added to Cart';
		const header = '';
		this.toastr.success(header, msg, {
			positionClass: 'toast-top-right',
		});
		this.cart.addToCart(product);
	}

    placeOrderOnAccount(reference_no:string=""):Observable<any>
    {
        const orderDetails = {
            "order_list": this.cart.orderList,
            "reference_no": reference_no,
            'payment_type':'account'
        }
        return this.baseService.placeOrderOnAccount(orderDetails);
    }
}
